import { ValidationResult, fluentValidator } from "sprint-common-web";

export const validateResolution = (input: string): ValidationResult => {
    const regex = /^\d{1,4}x\d{1,4}$/;
    return fluentValidator<string>()
        .when((resoloution) => !!resoloution && !regex.test(resoloution))
        .addError("Resolution should be in {width}x{height} format")
        .validate(input);
};
